export const styles = {
  button: 'flex-1',
};
